import { render } from "./saveBillSuccess.vue?vue&type=template&id=7906e5f7&scoped=true&ts=true"
import script from "./saveBillSuccess.vue?vue&type=script&lang=ts"
export * from "./saveBillSuccess.vue?vue&type=script&lang=ts"

import "./saveBillSuccess.vue?vue&type=style&index=0&id=7906e5f7&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7906e5f7"]])

export default __exports__